import { type PressEvent } from "react-aria-components";

import { Button } from "#components/v2/Button";

interface DropdownCTAProps {
  leftCTA: {
    action: (e: PressEvent) => void;
    text: string;
  };
  rightCTA: {
    action: (e: PressEvent) => void;
    text: string;
  };
}

export function DropdownCTA({ leftCTA, rightCTA }: DropdownCTAProps) {
  return (
    <div className="flex items-center justify-between gap-xl border-t border-outline-decorative px-4 pt-xs">
      <Button onPress={leftCTA.action} slot="close" variant="tertiary">
        {leftCTA.text}
      </Button>
      <Button onPress={rightCTA.action} slot="close" variant="primary">
        {rightCTA.text}
      </Button>
    </div>
  );
}
